module.exports = __webpack_public_path__ + "img/two2.2027f043.png";